import SprintReportPopupHeader from './SprintReportPopupHeader';

export default SprintReportPopupHeader;
